import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type EmojiIconProps = Partial<SVGIconProps>;

const EmojiIcon: FC<EmojiIconProps> = (props) => (
  <SVGIcon viewBox="0 0 17 16" {...props}>
    <path
      d="M6.77214 14.6615H10.7721C14.1055 14.6615 15.4388 13.3281 15.4388 9.99479V5.99479C15.4388 2.66146 14.1055 1.32812 10.7721 1.32812H6.77214C3.4388 1.32812 2.10547 2.66146 2.10547 5.99479V9.99479C2.10547 13.3281 3.4388 14.6615 6.77214 14.6615Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1055 6.5C11.6578 6.5 12.1055 6.05228 12.1055 5.5C12.1055 4.94772 11.6578 4.5 11.1055 4.5C10.5532 4.5 10.1055 4.94772 10.1055 5.5C10.1055 6.05228 10.5532 6.5 11.1055 6.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      d="M6.43359 6.5C6.98588 6.5 7.43359 6.05228 7.43359 5.5C7.43359 4.94772 6.98588 4.5 6.43359 4.5C5.88131 4.5 5.43359 4.94772 5.43359 5.5C5.43359 6.05228 5.88131 6.5 6.43359 6.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      d="M6.36953 8.86719H11.1695C11.5029 8.86719 11.7695 9.13385 11.7695 9.46719C11.7695 11.1272 10.4295 12.4672 8.76953 12.4672C7.10953 12.4672 5.76953 11.1272 5.76953 9.46719C5.76953 9.13385 6.0362 8.86719 6.36953 8.86719Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </SVGIcon>
);

export default EmojiIcon;
